import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import { filterTableList } from "../functions/filterTableList";
import { colors } from "../../../data/colors";
import { removeAccents } from "../../../utils/removeAccents";

const updateDictData = ({
  docValues,
  setDocValues,
  modalData,
  setModalData,
  windowValues,
  setWindowValues,
  closeMsg,
}: stdObject) => {
  let tempDocData = docValues;
  let data: stdObject = {};
  windowValues.list.forEach(
    (e: stdObject) => (data[e.code] = { name: e.name }),
  );
  if (tempDocData.issues[modalData.index].NUMSDD === modalData.code) {
    tempDocData.issues[modalData.index].TXTSDD = JSON.stringify({
      dict: modalData.dict,
      hideCodes: modalData.hideCodes,
      data,
    });
  }
  setDocValues({ ...tempDocData });
  setWindowValues({});
  setModalData({});
  closeMsg();
};

const chooseDictItem = (
  data: stdObject,
  active: boolean,
  { windowValues, setWindowValues }: stdObject,
) => {
  setWindowValues({
    ...windowValues,
    codes: active
      ? windowValues.codes.filter((e: stdObject) => e !== data.code)
      : [...windowValues.codes, data.code],
    list: active
      ? windowValues.list.filter((e: stdObject) => e.code !== data.code)
      : [...windowValues.list, data],
    table:
      windowValues.table.length === 0
        ? []
        : active
          ? removeAccents(data.code).includes(
              removeAccents(windowValues.search),
            )
            ? [...windowValues.table, data].sort(
                (a: stdObject, b: stdObject) => b.code - a.code,
              )
            : windowValues.table
          : windowValues.table.filter((e: stdObject) => e.code !== data.code),
  });
};

export const dictionaryModal = ({
  t,
  dictList,
  dictCounter,
  docValues,
  setDocValues,
  modalData,
  setModalData,
  windowValues,
  setWindowValues,
  closeMsg,
}: stdObject) => {
  return {
    title: modalData.title ?? "",
    inputs: [
      !modalData.showAll && {
        placeholder: t("p.searchByNameOrCode"),
        keysList: ["code", "name"],
        step: "DICT",
        value: windowValues.search ?? "",
        type: "text",
        style: { width: 100 },
        onChange: (e: { target: { value: SetStateAction<string> } }) =>
          filterTableList(e.target.value, true, dictCounter, {
            windowValues,
            setWindowValues,
            modalData,
            dictList,
          }),
      },
    ],
    table:
      "list" in windowValues &&
      [...windowValues.list, ...windowValues.table].length > 0
        ? [...windowValues.list, ...windowValues.table].map(
            (e: stdObject, index: number) => {
              return {
                data: [e.code, e.name],
                style: {
                  backgroundColor:
                    index < windowValues.list.length
                      ? index % 2 === 0
                        ? colors.lightGreen2
                        : colors.lightGreen
                      : index % 2 === 0
                        ? colors.lightGrey
                        : colors.white,
                },
                onClick: () => {
                  chooseDictItem(e, index < windowValues.list.length, {
                    windowValues,
                    setWindowValues,
                  });
                },
              };
            },
          )
        : [{ data: [], onClick: () => {} }],
    isList: true,
    tableStyle: { height: 300, width: 300 },
    buttons: [
      {
        label: t("p.update"),
        onClick: () =>
          updateDictData({
            docValues,
            setDocValues,
            modalData,
            setModalData,
            windowValues,
            setWindowValues,
            closeMsg,
          }),
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
